export default __webpack_public_path__ + "static/media/AE20.82661bc2.jpg";